import React from "react";
import {
    ITranslationsContext,
    TranslationsContext,
} from "../../../translations/TranslationsContext";
import { IUseFormHookResult, useForm } from "../FormContext";
import { CoolingType } from "../IProjectData";

export function useSectionHeading() {
    const _form: IUseFormHookResult = useForm();
    const _translations: ITranslationsContext | null =
        React.useContext(TranslationsContext);

    if (_form.data.generalInfo.values.coolingType === CoolingType.None) {
        return _translations?.phrases.tanksHeadings.noCooling;
    } else {
        return _translations?.phrases.tanksHeadings.widthCooling;
    }
}
